export const BASE_URL = 'https://www.tinywins.ai';

export const DEFAULT_OG_IMAGE = `${BASE_URL}/og/tinywins-og.jpg`;

export type SEOConfig = {
  title: string;
  description: string;
  keywords: string[];
  url?: string;
  image?: string;
  robots?: string;
  type?: 'website' | 'article';
};

export type BreadcrumbItem = {
  name: string;
  path: string;
};

export type JsonLdRecord = Record<string, unknown>;
